import ActionsForm from '@/shared/mixins/actionsForm'
import collapseQma from '../components/collapseQma/collapseQma.vue'
import filterRegister from '../components/filterRegister/filterRegister.vue'

export default {
  name: 'registerbasicQmaPIT',
  components: {collapseQma, filterRegister},
  mixins: [ActionsForm],
  data () {
    return {
      details: false,
      templateid: null,
      tipoTemplate: null,
      TipoQmaTemplate: 'LV'
    }
  },
  methods: {
    search (data) {
      this.$refs.collap.formSearch = data
      this.$refs.collap.expandirFiltro()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/registerbasicQMA/registerbasicQmaLV/registerbasicQmaLV.js